module.exports = __webpack_public_path__ + "static/media/mainimg-02.e36c28b2.png";